import styled from 'styled-components';

export const Turn = styled.section`
  & + & {
    margin-top: 14px;
  }
`;

export const TurnTitle = styled.h3`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 6px;
`;

/** One move: its sentences together, a line between moves. */
export const Move = styled.ul`
  list-style: none;
  padding: 6px 0;
  font-size: 14px;
  line-height: 1.4;

  & + & {
    border-top: 1px solid var(--line);
  }
`;

/** A small button in the game's top bar, styled like the view switch beside it. */
export const LogButton = styled.button`
  border: 0;
  border-radius: 9px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: rgba(255, 255, 255, .08);
  color: var(--muted);
`;

/** The log in the game's side panel on a wide screen: under the hand, using the rest of the panel's height. */
export const InlineLogArea = styled.section`
  padding: 8px 12px 16px;
  border-top: 1px solid var(--line);
  margin-top: 4px;
`;

/** One sentence of the log, with the cards it's about in front of it. */
export const Line = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;

  & + & {
    margin-top: 4px;
  }
`;

export const Cards = styled.span`
  display: flex;
  flex: none;
  align-items: center;
  gap: 3px;
  --card-w: 30px;
`;
